import React from 'react';
import { MessageCircle, FileText } from 'lucide-react';
import { Button } from './ui/button';

const ConsultationBanner = ({ onWhatsAppClick, onConsultationClick }) => {
    return (
        <div className="bg-gray-900 rounded-3xl p-8 md:p-12 text-center text-white shadow-2xl relative overflow-hidden my-16">
            <div className="absolute top-0 right-0 w-64 h-64 bg-red-600 opacity-10 rounded-full -mr-32 -mt-32"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-red-600 opacity-10 rounded-full -ml-32 -mb-32"></div>

            <div className="relative z-10 max-w-3xl mx-auto space-y-6">
                <h2 className="text-3xl md:text-4xl font-extrabold mb-4 italic tracking-tight">
                    Can't find your <span className="text-red-500 underline decoration-white/30 underline-offset-8">Respiratory</span> Medication?
                </h2>
                <p className="text-lg text-gray-400 font-medium">
                    We have access to 5000+ authentic life-saving medications. Our expert pharmacists can help you source any medicine from verified Indian manufacturers.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
                    <Button
                        onClick={onWhatsAppClick}
                        className="bg-green-600 hover:bg-green-700 text-white px-8 py-7 rounded-2xl text-lg font-bold flex items-center justify-center gap-3 shadow-lg hover:scale-105 transition-all"
                    >
                        <MessageCircle className="w-6 h-6" />
                        <span>Chat on WhatsApp</span>
                    </Button>
                    <Button
                        onClick={onConsultationClick}
                        variant="outline"
                        className="border-2 border-white/20 text-white hover:bg-white/10 px-8 py-7 rounded-2xl text-lg font-bold flex items-center justify-center gap-3 hover:scale-105 transition-all bg-transparent"
                    >
                        <FileText className="w-6 h-6" />
                        <span>Request Quotation</span>
                    </Button>
                </div>
                <p className="text-xs text-gray-500 font-semibold pt-4 flex items-center justify-center gap-2">
                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                    Pharmacists online now to assist you
                </p>
            </div>
        </div>
    );
};

export default ConsultationBanner;
